import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SeenEmailIcon = () => (
  <ImageIcon src={Images.SeenEmail} alt="empty-data/" />
);

export default SeenEmailIcon;
